var styleDataHash = "c11a91d6";
const injectCss = () => {
  var css = `.Oct9J,.ReactModalPortal,._81zx8,.glob_fontElementMap,button{font-family:var(--ricos-font-family,unset)}.T-bL1{display:flex}[dir] ._3Seni:hover{box-shadow:0 0 0 2px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] ._3Seni:hover,[dir] .s-JAr{border-radius:var(--ricos-native-whitebox-border-radius,0);cursor:default}[dir] .s-JAr{box-shadow:0 0 0 1px var(--ricos-focus-action-color,var(--ricos-action-color,#116dff))}[dir] .y2Ayo .s-JAr{box-shadow:none!important}.vS4G3{display:block;height:100%;position:absolute;top:0;width:100%}[dir] .vS4G3{cursor:move}[dir=ltr] .vS4G3{left:0}[dir=rtl] .vS4G3{right:0}.vS4G3.DhJyW{pointer-events:none}[dir] .-y1xL ::selection{background:transparent}.QQJkd{display:none}._81zx8{position:relative}.qpFNq{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{font-weight:300}[dir=ltr] .ReactModal__Content{direction:ltr}[dir=rtl] .ReactModal__Content{direction:rtl}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial)}.XLFSy{color:#333;text-decoration:none}.GZys3{display:block}.Pucuq{position:relative}._71qB6{overflow-x:auto;overflow-y:hidden}[dir=ltr] ._71qB6,[dir=rtl] ._71qB6{margin-left:-20px;margin-right:-20px}[dir] ._71qB6.tkW7-::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}[dir] ._71qB6.R2SjV::-webkit-scrollbar-thumb{background-color:transparent}._188k2{max-width:max-content!important;min-width:100%}._71qB6::-webkit-scrollbar{-webkit-appearance:none}[dir] ._71qB6::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}._71qB6::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_default = {
  "fontElementMap": "Oct9J",
  "pluginContainer": "_81zx8",
  "flex": "T-bL1",
  "isFocusable": "_3Seni",
  "hasFocus": "s-JAr",
  "dragImageView": "y2Ayo",
  "overlay": "vS4G3",
  "noPointerEventsOnFocus": "DhJyW",
  "hideTextSelection": "-y1xL",
  "hidden": "QQJkd",
  "pluginContainerMobile": "qpFNq",
  "isImage": "XLFSy",
  "anchor": "GZys3",
  "horizontalScrollbarWrapper": "Pucuq",
  "pluginWithHorizontalScrollbar": "_71qB6",
  "show": "tkW7-",
  "hide": "R2SjV",
  "horizontalScrollbar": "_188k2"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
